import { SET_SCRIPTS, SET_JOBS, SET_SELECTED_JOBS, SET_TASKS } from "./types";

const state = {
  scripts: [],
  jobs: [],
  selectedJob: [],
  tasks: []
};

const mutations = {
  [SET_SCRIPTS](state, scripts) {
    state.scripts = scripts;
  },
  [SET_JOBS](state, jobs) {
    state.jobs = jobs;
  },
  [SET_SELECTED_JOBS](state, job) {
    state.selectedJob = job;
  },
  [SET_TASKS](state, tasks) {
    state.tasks = tasks;
  }
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
